import VueCookies from "vue-cookies";  // 引用cookie

const TokenKey = 'User-Token'
import {store} from "@/store/index.js";
export function getToken() {
  return VueCookies.get(TokenKey)
}

//  设置token保存7天
export function saveToken(token) {
  return VueCookies.set(TokenKey, token, '7d')
}

export function removeToken() {
  // await VueCookies.remove(TokenKey)
  return VueCookies.remove(TokenKey)
}
